import { EventCreatorMap } from '../models/helpers';
import * as UserActions from '@app/core/user/store/actions/user.actions';
import * as RouterActions from '@app/store/actions/router.action';

import pageview from './pageview';
import virtualPageview from './virtual-pageview';
import privacyPolicy from './privacy-policy';
import account from './account';
import product from './product';
import search from './search';
import mmao from './mmao';
import catalog from './catalog';
import landings from './landings';
import navigation from './navigation';
import promo from './promo';
import accessibility from './accessibility';

const eventsMap: EventCreatorMap = {
  ...catalog,
  ...account,
  ...product,
  ...search,
  ...mmao,
  ...landings,
  ...navigation,
  ...promo,
  ...accessibility,
  // TODO : Remove NAVIGATION_END action and use @ngrx/router-store 's ROUTER_NAVIGATED when stable version is available
  [RouterActions.NAVIGATION_END]: pageview,
  [UserActions.UPDATE_PRIVACY_SETTINGS]: privacyPolicy,
  [UserActions.POPIN_AUTH_SHOWED]: virtualPageview
};

export default eventsMap;
